
import { ReallySticky } from "@/global-scripts/ReallySticky";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import SearchModule from "../../store/modules/SearchModule";
import $ from "jquery";

const PULSATE_DURATION = 3750;

@Component
export default class SearchButton extends Vue {
  private readonly searchModule = getModule(SearchModule, this.$store);

  private pulseTimer: ReturnType<typeof setTimeout> | undefined = undefined;
  private pulsating = false;
  private reallySticky!: ReallySticky;

  private get componentClasses(): string {
    const classes = [];
    if (this.pulsating) {
      classes.push("is-pulsating");
    }
    if (this.searchModalOpen) {
      classes.push("SearchButton--close");
    }
    return classes.join(" ");
  }

  private get searchModalOpen(): boolean {
    return this.searchModule.searchModalOpen;
  }

  private openSearchModal() {
    this.searchModule.setSearchModalOpen(true);
  }

  private closeSearchModal() {
    this.searchModule.setSearchModalOpen(false);
  }

  private onClick() {
    if (!this.searchModalOpen) {
      this.$tracker.trackSearchEvent("open");
      this.openSearchModal();
    } else {
      this.closeSearchModal();
    }
    setTimeout(() => {
      this.reallySticky.update();
    }, 1000);
  }

  private pulsate(delay = 250) {
    clearTimeout(this.pulseTimer);
    this.pulseTimer = setTimeout(() => {
      // Pulsate after delay
      this.pulsating = true;
      this.pulseTimer = setTimeout(() => {
        this.pulsating = false;
      }, PULSATE_DURATION);
    }, delay);
  }

  created() {
    // Listen for 'pulsateSearchButton' parent event
    this.$parent.$on("pulsateSearchButton", this.pulsate);
    // Restore & update sticky
    this.$parent.$on("updateSticky", () => {
      this.reallySticky.restore();
      this.reallySticky.update();
    });

    this.$nextTick(() => {
      this.reallySticky = new ReallySticky($(".SearchButton"), {
        containerSel: ".page > .main-wrapper",
        fixedTopNavSel: ".top-nav",
        offset: ($(window).width() as number) < 992 ? 20 : 0,
        breakpoint: 768,
      });

      $(window).on("scroll", () => {
        this.reallySticky.update();
      });
      $(window).on("resize", () => {
        this.reallySticky.restore();
      });
    });
  }
}
